module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box_header"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("Thêm lớp học")]), _c('label', {
    staticClass: "title-pc"
  }, [_vm._v(_vm._s(_vm.lstPC.name))]), _c('div', {
    staticClass: "clearfix"
  })]), _c('div', {
    staticClass: "box-content"
  }, [_c('div', {
    staticClass: "box-pc-step"
  }, [_c('div', {
    staticClass: "item-pc-content"
  }, [_c('div', {
    staticClass: "form-group",
    class: [_vm.isSubmitFinish && (_vm.key_name.length === 0 || _vm.key_exists) ? 'error' : '']
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Tên lớp học *")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.key_name),
      expression: "key_name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "key_name",
      "maxlength": "125",
      "placeholder": "Nhập",
      "autofocus": "autofocus"
    },
    domProps: {
      "value": (_vm.key_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.key_name = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), (_vm.isSubmitFinish && _vm.key_name.length === 0) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("Vui lòng nhập tên lớp học")]) : _vm._e(), (_vm.isSubmitFinish && _vm.key_exists) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("Tên lớp học đã tồn tại")]) : _vm._e()]), _c('div', {
    staticClass: "form-group",
    class: [_vm.isSubmitFinish && (_vm.key_grade.length === 0 || _vm.key_grade === 0) ? 'error' : '']
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Khối lớp *")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.key_grade),
      expression: "key_grade",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "key_grade"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.key_grade = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "disabled",
      "value": "0"
    },
    domProps: {
      "selected": _vm.key_grade === 0
    }
  }, [_vm._v("Chọn khối lớp")]), _vm._l((_vm.grades), function(o) {
    return _c('option', {
      domProps: {
        "value": o.id,
        "selected": _vm.key_grade === o.id
      }
    }, [_vm._v(_vm._s(o.name))])
  })], 2), _c('span', {
    staticClass: "required"
  }, [_vm._v("Vui lòng chọn khối lớp")])]), _c('div', {
    staticClass: "form-group",
    class: [_vm.isSubmitFinish && _vm.lstIcons.length === 0 ? 'error' : '']
  }, [_c('div', {
    staticClass: "box-icon"
  }, [_vm._m(0), _c('div', {
    attrs: {
      "id": "list_icon"
    }
  }, [_c('div', {
    staticClass: "box-button"
  }, [_c('div', {
    staticClass: "item-button"
  }, [_c('input', {
    attrs: {
      "id": "icon",
      "name": "icon",
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onIconChange
    }
  }), _c('span', [_vm._v("Tải ảnh lên")])]), _c('div', {
    staticClass: "item-button"
  }, [_c('span', {
    on: {
      "click": _vm.openLibrary
    }
  }, [_vm._v("Chọn từ thư viện")])])]), _c('div', {
    staticClass: "box-item-icon"
  }, [_vm._l((_vm.lstIcons), function(icon, index) {
    return (icon) ? _c('div', {
      staticClass: "box-item"
    }, [_c('span', {
      staticClass: "material-icons remove",
      on: {
        "click": function($event) {
          return _vm.deleteIcon(index)
        }
      }
    }, [_vm._v("cancel")]), _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": icon.src
      }
    })]) : _vm._e()
  }), _c('span', {
    staticClass: "required"
  }, [_vm._v("Vui lòng upload ảnh đại diện")]), _c('div', {
    staticClass: "clearfix"
  })], 2), _c('div', {
    staticClass: "clearfix"
  })])])]), _c('div', {
    staticClass: "form-group",
    class: [_vm.isSubmitFinish && _vm.lstIcons.length === 0 ? 'error' : '']
  }, [_c('div', {
    staticClass: "box-item-private"
  }, [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.key_private),
      expression: "key_private"
    }],
    attrs: {
      "type": "radio",
      "id": "private1",
      "name": "private",
      "value": "0"
    },
    domProps: {
      "checked": _vm.key_private == 0,
      "checked": _vm._q(_vm.key_private, "0")
    },
    on: {
      "change": function($event) {
        _vm.key_private = "0"
      }
    }
  }), _c('label', {
    attrs: {
      "for": "private1"
    }
  }, [_vm._v("Tất cả mọi thành viên đều thấy và yêu cầu tham gia")])]), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.key_private),
      expression: "key_private"
    }],
    attrs: {
      "type": "radio",
      "id": "private2",
      "name": "private",
      "value": "1"
    },
    domProps: {
      "checked": _vm.key_private == 1,
      "checked": _vm._q(_vm.key_private, "1")
    },
    on: {
      "change": function($event) {
        _vm.key_private = "1"
      }
    }
  }), _c('label', {
    attrs: {
      "for": "private2"
    }
  }, [_vm._v("Chỉ tôi được thêm thành viên vào lớp này")])])])])]), _c('div', {
    staticClass: "item-pc-bottom"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "active",
    on: {
      "click": function($event) {
        return _vm.submitSave()
      }
    }
  }, [_vm._v("Thêm mới")]), _c('a', {
    staticClass: "button",
    on: {
      "click": _vm.backClasses
    }
  }, [_vm._v("Huỷ yêu cầu")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label"
  }, [_c('strong', [_vm._v("Ảnh đại diện lớp học: "), _c('span', [_vm._v("(Kích thước đề nghị: 300x300 px)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5234294c","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Classes/add.vue
// module id = 1560
// module chunks = 0